<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          label="Наименование, указанное в ЕГРЮЛ"
          outlined
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="v.inn.$model"
          v-mask="['##########']"
          :errorMessages="getValidationErrorText(v.inn)"
          label="ИНН"
          outlined
          :disabled="true"
        />
      </v-col>
    </v-row>

    <Assignee
      :v="v"
      title="Лицо, действующее от имени иностранного юридического лица без доверенности"
    />
  </div>
</template>

<script>
import { EMOJI, getValidationErrorText, INN_ROD } from "@/utils/validate";
import Assignee, { assigneeModel, assigneeValidation } from './Assignee';
import { maxLength, minLength, required } from "vuelidate/lib/validators";

export const foreignOrganizationModel = {
  name: '',
  inn: '',
  ...assigneeModel,
};

export const foreignOrganizationValidation = {
  name: {
    required,
    maxLength: maxLength(1000),
    EMOJI,
  },
  inn: {
    required,
    minLength: minLength(10),
    INN: INN_ROD,
  },
  ...assigneeValidation,
};

export default {
  name: 'ForeignOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    Assignee,
  },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>
